export const ofertaDocument = {
	id: 'oferta',
	name: 'Оферта',
	url: 'https://s3.twcstorage.ru/algocode-static/docs/Otus/%D0%9E%D1%84%D0%B5%D1%80%D1%82%D0%B0%20%D0%BE%D1%82%2014.08.pdf',
};

export const userAgreementDocument = {
	id: 'user-agreement',
	name: 'Пользовательское соглашение',
	url: 'https://s3.twcstorage.ru/algocode-static/docs/Otus/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%20algocode.pdf',
};

export const orderOfProcessingPersonalDataDocument = {
	id: 'order-of-processing-personal-data',
	name: 'Политика обработки персональных данных',
	url: 'https://otus.ru/legal/privacy/',
};

export const consentOfProcessingPersonalDataDocument = {
	id: 'consent-of-processing-personal-data',
	name: 'Согласие на обработку персональных данных',
	url: 'https://s3.twcstorage.ru/algocode-static/docs/Otus/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%BD%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83_%D0%9F%D0%94%D0%BD_%D1%84%D0%BE%D1%80%D0%BC%D0%B0_%D1%80%D0%B5%D0%B4_14.08.2026.pdf',
};

export const consentToAdvertisingMailingDocument = {
	id: 'consent-to-advertising-mailing',
	name: 'Согласие на рекламную рассылку',
	url: 'https://s3.twcstorage.ru/algocode-static/docs/Otus/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%BD%D0%B0_%D1%80%D0%B5%D0%BA%D0%BB%D0%B0%D0%BC%D0%BD%D1%83%D1%8E_%D1%80%D0%B0%D1%81%D1%81%D1%8B%D0%BB%D0%BA%D1%83.pdf',
};

export const notificationOfIssuanceOfLicenseDocument = {
	id: 'notification-of-issuance-of-license',
	name: 'Лицензия на осуществление образовательной деятельности № 039825 от 28.12.2018',
	url: 'https://s3.twcstorage.ru/algocode-static/docs/Otus/%D0%9B%D0%B8%D1%86%D0%B5%D0%BD%D0%B7%D0%B8%D1%8F%20%2B%20%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%E2%84%961.1.pdf',
};

export const educationDocuments = [
	ofertaDocument,
	orderOfProcessingPersonalDataDocument,
	consentOfProcessingPersonalDataDocument,
	consentToAdvertisingMailingDocument,
	notificationOfIssuanceOfLicenseDocument,
	userAgreementDocument,
];
